import { withHTMLHeadSEO } from 'components/common';
import CaseStudy from 'components/features/authoring/case-study/CaseStudy';

const CaseStudyMetadataAuthoringPage = () => <CaseStudy />;

export { CaseStudyMetadataAuthoringPage as BaseCaseStudyMetadataAuthoringPage };
export default withHTMLHeadSEO({ title: 'Case study Authoring' })(CaseStudyMetadataAuthoringPage);
